/* Frozen Thai rain for [data-rain] canvases.
   Lives in an external file (not inline) because the storefront's
   instant-loader app swaps page content into the DOM, and inline
   scripts injected that way never execute. A MutationObserver
   re-initializes any canvas the loader swaps in. */
(function () {
	if (window.SKRain) return;
	window.SKRain = true;

	var GLYPHS = 'กขฅงจฉชซญฎดตถทนบปผฝพฟภมยรลวศษสหอฮ๐๑๒๓๔๕๖๗๘๙๐๑๒๓๔๕๖๗๘๙';
	var CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789#';
	var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	function rand(n) { return Math.floor(Math.random() * n); }

	/* ---- title scramble (.sk-scramble with data-text) ---- */
	function scramble(el) {
		var original = el.getAttribute('data-text');
		if (!original || reducedMotion) return;
		// on a hidden/prerendered page rAF is paused and the title would
		// freeze mid-scramble; start the effect when the page is visible
		if (document.visibilityState === 'hidden') {
			document.addEventListener('visibilitychange', function once() {
				if (document.visibilityState !== 'visible') return;
				document.removeEventListener('visibilitychange', once);
				scramble(el);
			});
			return;
		}
		var holder = el.closest('[data-scramble-speed]');
		var rawSpeed = holder ? parseInt(holder.getAttribute('data-scramble-speed'), 10) : 5;
		var speed = (11 - (rawSpeed || 5)) * 0.5;
		el.style.width = el.offsetWidth + 'px'; // lock width against layout shift
		var totalFrames = original.length * speed;
		var frame = 0;
		function tick() {
			el.textContent = original.split('').map(function (ch, i) {
				if (ch === ' ') return ' ';
				if (frame > i * speed) return ch;
				return CHARS[rand(CHARS.length)];
			}).join('');
			frame++;
			if (frame <= totalFrames) requestAnimationFrame(tick);
			else {
				el.textContent = original;
				el.style.width = '';
			}
		}
		tick();
	}

	function initRain(canvas) {
		var ctx = canvas.getContext('2d');
		if (!ctx) return;
		var fontSize = 18;
		var scene = null;
		var pool = []; // one random column per slot, kept across rebuilds
		var size = '';
		// the newsletter rain hugs both edges; banners hug the right
		var centerClear = canvas.getAttribute('data-rain-layout') === 'center-clear';
		var darkGlyphs = canvas.getAttribute('data-glyph-ink') === 'dark';
		var glyphRGB = darkGlyphs ? '0,0,0' : '255,255,255';
		var glyphAlpha = parseFloat(canvas.getAttribute('data-rain-alpha')) || (darkGlyphs ? 0.13 : 0.16);

		function buildScene() {
			var box = canvas.parentElement.getBoundingClientRect();
			size = Math.round(box.width) + 'x' + Math.round(box.height);
			canvas.width = box.width;
			canvas.height = box.height;
			ctx.font = '700 ' + fontSize + 'px "JetBrains Mono", Menlo, monospace';
			var cols = Math.floor(canvas.width / (fontSize * 1.4));
			var rows = Math.max(4, Math.floor(canvas.height / fontSize));
			scene = [];
			for (var i = 0; i < cols; i++) {
				var frac = i / cols;
				if (centerClear) {
					if (frac > 0.28 && frac < 0.72) { scene.push(null); continue; }
				} else if (frac < 0.55) { scene.push(null); continue; }
				if (!pool[i]) {
					pool[i] = {
						x: i * fontSize * 1.4,
						headRow: 4 + rand(Math.max(4, rows - 4)),
						trail: 5 + rand(12),
						drift: 3 + rand(4),
						delay: Math.random() * 0.25,
						chars: {}
					};
				}
				scene.push(pool[i]);
			}
		}

		function charAt(col, row) {
			if (!col.chars[row]) col.chars[row] = GLYPHS[rand(GLYPHS.length)];
			return col.chars[row];
		}

		function draw(progress) {
			ctx.clearRect(0, 0, canvas.width, canvas.height);
			scene.forEach(function (col) {
				if (!col) return;
				var p = Math.min(1, Math.max(0, (progress - col.delay) / (1 - col.delay)));
				var eased = 1 - Math.pow(1 - p, 3);
				var offset = col.drift * (1 - eased) * fontSize;
				var fade = 0.4 + 0.6 * eased;
				for (var t = 0; t < col.trail; t++) {
					var row = col.headRow - t;
					var y = row * fontSize + offset;
					if (y < 0) break;
					ctx.fillStyle = 'rgba(' + glyphRGB + ',' + glyphAlpha * (1 - t / col.trail) * fade + ')';
					ctx.fillText(charAt(col, row), col.x, y);
				}
			});
		}

		function settle() {
			var DURATION = 2200, t0 = null;
			function frame(ts) {
				if (t0 === null) t0 = ts;
				var progress = Math.min(1, (ts - t0) / DURATION);
				draw(progress);
				if (progress < 1) requestAnimationFrame(frame);
			}
			requestAnimationFrame(frame);
		}

		function settleIn() {
			buildScene();
			if (reducedMotion) { draw(1); return; }
			// rAF is paused in hidden and prerendered pages (the instant-loader
			// app prerenders navigations), so a hidden page paints the frozen
			// frame at once — the canvas must never sit empty — and plays the
			// settle animation when it becomes visible.
			if (document.visibilityState === 'hidden') {
				draw(1);
				document.addEventListener('visibilitychange', function once() {
					if (document.visibilityState !== 'visible') return;
					document.removeEventListener('visibilitychange', once);
					// a page that loaded hidden may have had no layout at all
					// (canvas measured 0-wide) — re-measure before animating
					buildScene();
					settle();
				});
			} else {
				settle();
			}
		}

		// Phones fire 'resize' whenever the address bar shows or hides while
		// scrolling. Only redraw when the box itself changed size, and reuse
		// the same columns and glyphs, so the pattern never reshuffles.
		var resizeTimer;
		window.addEventListener('resize', function () {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(function () {
				if (!scene) return;
				if (!canvas.isConnected) return;
				var box = canvas.parentElement.getBoundingClientRect();
				if (Math.round(box.width) + 'x' + Math.round(box.height) === size) return;
				buildScene();
				draw(1);
			}, 250);
		});

		settleIn();
	}

	function initAll() {
		document.querySelectorAll('canvas[data-rain]:not([data-sk-rain-init])').forEach(function (canvas) {
			canvas.setAttribute('data-sk-rain-init', '');
			initRain(canvas);
		});
		document.querySelectorAll('.sk-scramble:not([data-sk-scramble-done])').forEach(function (el) {
			el.setAttribute('data-sk-scramble-done', '');
			scramble(el);
		});
	}

	function boot() {
		initAll();
		// re-init canvases swapped in later (instant loader, section reloads)
		var pending;
		new MutationObserver(function () {
			clearTimeout(pending);
			pending = setTimeout(initAll, 100);
		}).observe(document.body, { childList: true, subtree: true });
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', boot);
	} else {
		boot();
	}
})();
